module.exports = """
  fragment gene_context on HomePageModuleContextGene {
    id
    href
  }
"""
